/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Event History Badge Icon component.
 */
export const EventHistoryBadgeIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M16.085 11.0903C19.3525 11.0906 22 13.738 22 16.9995C22 20.261 19.3525 22.9085 16.085 22.9087C12.8232 22.9087 10.1817 20.2612 10.1816 16.9995C10.1816 13.7378 12.8232 11.0903 16.085 11.0903ZM16.0908 12.272C13.479 12.272 11.3633 14.3878 11.3633 16.9995C11.3633 19.6112 13.479 21.7261 16.0908 21.7261C18.7024 21.7259 20.8174 19.6111 20.8174 16.9995C20.8174 14.3879 18.7025 12.2722 16.0908 12.272ZM6.5459 2.90967H15.6367V1.09131H17.4541V2.90967H18.3633C19.363 2.90987 20.1814 3.72743 20.1816 4.72705V11.5454C19.6338 11.1339 19.0215 10.8035 18.3633 10.5708V9.27295H3.81836V19.272H9.66211C9.89476 19.93 10.2244 20.5426 10.6357 21.0903H3.81836C2.81849 21.0903 2.0002 20.2718 2 19.272V4.72705C2.00026 3.72731 2.81852 2.90967 3.81836 2.90967H4.72754V1.09131H6.5459V2.90967ZM16.3857 14.0454V17.147L19.0449 18.7251L18.6016 19.4517L15.5 17.5903V14.0454H16.3857ZM3.81836 7.45459H18.3633V4.72705H3.81836V7.45459Z' fill={iconColor} />
    </svg>
  );
};

export default EventHistoryBadgeIcon;
